export * from "./event";
import { isNumber } from '@zenlayer/zen-design/esm/_util/defineType';
import { getTeamConfig } from "./event";
import dayjs from '@zenlayer/zen-design/esm/_util/day';
import { getServiceInfo } from "../../function/getProductInfo"; //后付费承诺期，和业务接口返回的数据取交集  return [6,12,...]

/**
 * 后付费承诺期，和业务接口返回的数据取交集
 * @function
 */

export var getTeamConfig_POST_PAID_PROMISE_Term = function getTeamConfig_POST_PAID_PROMISE_Term() {
  try {
    var _getTeamConfig$POST_P, _getTeamConfig$POST_P2, _getTeamConfig$POST_P3, _getTeamConfig$POST_P4;

    return ((_getTeamConfig$POST_P = getTeamConfig()['POST_PAID_PROMISE:DEFAULT_CATEGORY']) === null || _getTeamConfig$POST_P === void 0 ? void 0 : (_getTeamConfig$POST_P2 = _getTeamConfig$POST_P.conditionDefine) === null || _getTeamConfig$POST_P2 === void 0 ? void 0 : (_getTeamConfig$POST_P3 = _getTeamConfig$POST_P2.find(function (i) {
      return i.uuid === 'month';
    })) === null || _getTeamConfig$POST_P3 === void 0 ? void 0 : (_getTeamConfig$POST_P4 = _getTeamConfig$POST_P3.values) === null || _getTeamConfig$POST_P4 === void 0 ? void 0 : _getTeamConfig$POST_P4.map(function (i) {
      return Number(i.uuid);
    })) || [];
  } catch (e) {
    return [];
  }
};
/**
 * 是否开启后付费承诺
 * @function
 * @return boolean
 */

export var getTeamConfig_POST_PAID_PROMISE_Enable = function getTeamConfig_POST_PAID_PROMISE_Enable() {
  var _getTeamConfig$POST_P5;

  return ((_getTeamConfig$POST_P5 = getTeamConfig()['POST_PAID_PROMISE:DEFAULT_CATEGORY']) === null || _getTeamConfig$POST_P5 === void 0 ? void 0 : _getTeamConfig$POST_P5.configValue) === 'true' && !!getTeamConfig_POST_PAID_PROMISE_Term().length;
};
/**
 * 获取teamConfig中某个key的信息
 * @function
 */

export var getTeamConfig_quota = function getTeamConfig_quota(key) {
  var _getTeamConfig$;

  var strJSON = ((_getTeamConfig$ = getTeamConfig()["QUOTA:".concat(key)]) === null || _getTeamConfig$ === void 0 ? void 0 : _getTeamConfig$.configValue) || '{}';

  try {
    var quota = Number(JSON.parse(strJSON).quota);

    if (isNumber(quota)) {
      return quota;
    } else {
      throw new Error(quota.toString() + ' is not a number!');
    }
  } catch (error) {
    console.error('[portal-utils]getTeamConfig_quota:', error);
    return 0;
  }
};
/**
 * 获取teamConfig中MAINTENANCE:DEFAULT_CATEGORY的信息
 * @function
 */

export var getTeamConfig_maintenance = function getTeamConfig_maintenance() {
  try {
    var _info$conditionDefine, _getServiceInfo;

    var info = getTeamConfig()['MAINTENANCE:DEFAULT_CATEGORY'];

    var _JSON$parse = JSON.parse((info === null || info === void 0 ? void 0 : info.configValue) || '{}'),
        dutation = _JSON$parse.dutation,
        start_time = _JSON$parse.start_time;

    var isBefor = dayjs().isAfter(dayjs(start_time));

    if (!isBefor) {
      return undefined;
    }

    var serviceInfo = info === null || info === void 0 ? void 0 : (_info$conditionDefine = info.conditionDefine) === null || _info$conditionDefine === void 0 ? void 0 : _info$conditionDefine.find(function (i) {
      return i.uuid === 'serviceSn';
    }).values[0];
    return {
      dutation: dutation,
      start_time: start_time,
      serviceSn: serviceInfo.uuid,
      serviceName: (_getServiceInfo = getServiceInfo(serviceInfo.uuid)) === null || _getServiceInfo === void 0 ? void 0 : _getServiceInfo.serviceName
    };
  } catch (error) {
    return undefined;
  }
};